import { useEffect } from 'react';

export default function Done() {
    useEffect(() => {
        const message = {
            type: 'sharpsports:sync-complete',
            status: 'success',
            timestamp: Date.now()
        };

        // Post to parent window (for iframe integration)
        if (window.parent && window.parent !== window) {
            window.parent.postMessage(message, '*');
        }

        // Post to current window (for mobile webview integration)
        window.postMessage(message, '*');
    }, []);

    return null;
}
